var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      staticClass: "business-order-view-modal business-order-view-modal",
      attrs: {
        title: _vm.$t("businessOrders.details.title"),
        config: { focusFirst: false }
      }
    },
    [
      _c("spinner", { attrs: { active: _vm.isActive } }),
      _c(
        "template",
        { slot: "titleTooltip" },
        [
          _c("button-tooltip", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.bottom",
                value: {
                  content: _vm.$t("businessOrders.create.tooltip"),
                  delay: { show: 500, hide: 300 }
                },
                expression:
                  "{\n            content: $t('businessOrders.create.tooltip'),\n            delay: { show: 500, hide: 300 },\n        }",
                modifiers: { bottom: true }
              }
            ]
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "v-spacing-sm" },
        [
          _c(
            "flex-row",
            { staticClass: "flex--no-wrap", attrs: { "column-spacing": "lg" } },
            [
              _c(
                "div",
                { staticClass: "col col--wrap-text" },
                [
                  _c(
                    "value-wrapper",
                    { attrs: { label: _vm.$t("businessOrders.labels.id") } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("valueOrDash")(_vm.businessOrder.id)) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col col--wrap-text" },
                [
                  _c(
                    "value-wrapper",
                    {
                      attrs: {
                        label: _vm.$t("businessOrders.labels.referenceNo")
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("valueOrDash")(
                              _vm.businessOrder.referenceNumber
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "value-wrapper",
                    {
                      attrs: {
                        label: _vm.$t("businessOrders.labels.warehouseId")
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("valueOrDash")(
                              _vm.businessOrder.warehouseName
                            )
                          ) +
                          "\n                    "
                      ),
                      _vm.businessOrder.isWarehouseManuallySelected
                        ? _c(
                            "template",
                            { slot: "labelTooltip" },
                            [
                              _c("button-tooltip", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.bottom",
                                    value: {
                                      content: _vm.$t(
                                        "businessOrders.warehouse.detailsTooltip"
                                      ),
                                      delay: { show: 500, hide: 300 }
                                    },
                                    expression:
                                      "{\n                                content: $t('businessOrders.warehouse.detailsTooltip'),\n                                delay: { show: 500, hide: 300 },\n                            }",
                                    modifiers: { bottom: true }
                                  }
                                ],
                                attrs: { "display-m": "" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "value-wrapper",
                    {
                      attrs: {
                        label: _vm.$t("businessOrders.labels.orderType")
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("valueOrDash")(
                              _vm.$options.BusinessOrderTypeLabels[
                                _vm.businessOrder.orderType
                              ]
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "flex-row",
            { staticClass: "flex--no-wrap", attrs: { "column-spacing": "lg" } },
            [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "value-wrapper",
                    {
                      attrs: { label: _vm.$t("businessOrders.labels.status") }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("valueOrDash")(
                              _vm.$options.BusinessOrderStatusLabels[
                                _vm.businessOrder.status
                              ]
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "value-wrapper",
                    {
                      attrs: { label: _vm.$t("businessOrders.labels.shipDate") }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("valueOrDash")(
                              _vm._f("date")(
                                _vm.businessOrder.shipDate,
                                "short",
                                null
                              )
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "value-wrapper",
                    {
                      attrs: { label: _vm.$t("businessOrders.labels.carrier") }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("valueOrDash")(_vm.businessOrder.carrier)
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "flex-row",
            { staticClass: "flex--no-wrap", attrs: { "column-spacing": "lg" } },
            [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "value-wrapper",
                    {
                      attrs: {
                        label: _vm.$t("businessOrders.labels.carrierProNumber")
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("valueOrDash")(
                              _vm.businessOrder.carrierProNumber
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm.businessOrder.internalHoldReason
        ? _c(
            "section",
            [
              _c(
                "h2",
                { staticClass: "collapsible-title heading-with-separator" },
                [
                  _c("span", { staticClass: "heading-with-separator__inner" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("businessOrders.labels.holdTitle")) +
                        "\n            "
                    )
                  ])
                ]
              ),
              _vm.businessOrder.internalHoldReason
                ? _c(
                    "flex-row",
                    {
                      staticClass: "flex--no-wrap",
                      attrs: { "column-spacing": "lg" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "value-wrapper",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "businessOrders.labels.holdReasonSN"
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("valueOrDash")(
                                      _vm.businessOrder.internalHoldReason
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm.businessOrder.internalHoldComment
                ? _c(
                    "flex-row",
                    {
                      staticClass: "flex--no-wrap",
                      attrs: { "column-spacing": "lg" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "value-wrapper",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "businessOrders.labels.holdCommentsSN"
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("valueOrDash")(
                                      _vm.businessOrder.internalHoldComment
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        _vm.isTabletSize ? "div" : "base-scroll-container",
        { tag: "component", attrs: { "is-in-modal": "" } },
        [
          _c("consignee-information", {
            attrs: { "business-order": _vm.businessOrder }
          }),
          _c("order-information", {
            attrs: { "business-order": _vm.businessOrder }
          }),
          _c("handling-units", {
            class: {
              "business-order-view-modal__handling-units": _vm.noDocuments
            },
            attrs: {
              "business-order": _vm.businessOrder,
              "is-visible":
                _vm.canDocumentsBeEdited || _vm.canDocumentsBePreviewed
            }
          }),
          _c("form-wrapper", {
            ref: "form",
            attrs: {
              id: "upload-form",
              "in-modal": true,
              "scroll-on-error": true
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var invalid = ref.invalid
                  var loading = ref.loading
                  return [
                    _c("document-upload-section", {
                      attrs: {
                        "dropzone-options": _vm.dropzoneOptions,
                        "file-upload-title": _vm.shippingLabelUploadTitle,
                        "file-upload-description": _vm.$t(
                          "businessOrders.labels.shippingLabelDescription"
                        ),
                        "is-edit": _vm.canDocumentsBeEdited,
                        "is-preview": _vm.canDocumentsBePreviewed,
                        "shipping-documents": _vm.shippingLabels,
                        "file-type":
                          _vm.$options.OrderDocumentTypes.ShippingLabel,
                        "order-id": _vm.businessOrder.id
                      },
                      on: {
                        error: _vm.handleUploadError,
                        duplicate: _vm.handleDuplicateDocument,
                        "max-file-length": _vm.handleMaxFileLength,
                        "max-files-reached": _vm.handleMaxFilesReached,
                        "invalid-file-name": _vm.handleInvalidFileName
                      }
                    }),
                    _c("document-upload-section", {
                      attrs: {
                        "dropzone-options": _vm.dropzoneOptionsBillOfLanding,
                        "file-upload-title": _vm.billOfLandingUploadTitle,
                        "file-upload-description": _vm.$t(
                          "businessOrders.labels.billOfLandingDescription"
                        ),
                        "is-edit": _vm.canDocumentsBeEdited,
                        "is-preview": _vm.canDocumentsBePreviewed,
                        "shipping-documents": _vm.billOfLandingDocuments,
                        "file-type":
                          _vm.$options.OrderDocumentTypes.BillOfLading,
                        "order-id": _vm.businessOrder.id
                      },
                      on: {
                        error: _vm.handleUploadError,
                        duplicate: _vm.handleDuplicateDocument,
                        "max-file-length": _vm.handleMaxFileLength,
                        "max-files-reached": _vm.handleMaxFilesReached,
                        "invalid-file-name": _vm.handleInvalidFileName
                      }
                    }),
                    _c("document-upload-section", {
                      attrs: {
                        "dropzone-options": _vm.dropzoneOptions,
                        "file-upload-title":
                          _vm.miscellaneousShippingDocumentUploadTitle,
                        "file-upload-description": _vm.$t(
                          "businessOrders.labels.shippingDocumentDescription"
                        ),
                        "is-edit": _vm.canDocumentsBeEdited,
                        "is-preview": _vm.canDocumentsBePreviewed,
                        "shipping-documents":
                          _vm.miscellaneousShippingDocuments,
                        "file-type":
                          _vm.$options.OrderDocumentTypes.ShippingDocument,
                        "order-id": _vm.businessOrder.id
                      },
                      on: {
                        error: _vm.handleUploadError,
                        duplicate: _vm.handleDuplicateDocument,
                        "max-file-length": _vm.handleMaxFileLength,
                        "max-files-reached": _vm.handleMaxFilesReached,
                        "invalid-file-name": _vm.handleInvalidFileName
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "modal__actions modal__actions--with-scroll" },
        [
          _c(
            "base-button",
            {
              attrs: { id: "closeOrderDetailsBtn", "for-modal": "" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("general.close")) +
                  "\n        "
              )
            ]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }